
import "../DataTable.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_DataTableRowVirtual";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_DataTableRowVirtual__root","alignCenter":"wds_1_76_1_DataTable__alignCenter","stickyActionCell":"wds_1_76_1_DataTable__stickyActionCell","thContainer":"wds_1_76_1_DataTable__thContainer","thead":"wds_1_76_1_DataTableRowVirtual__thead"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




